import * as Yup from 'yup';
import { telephoneSchemaRequired } from '../../../models/schema/telephoneSchema';
import { MESSAGE_ERREUR_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE, MESSAGE_ERREUR_NOM_OBLIGATOIRE, MESSAGE_ERREUR_PRENOM_OBLIGATOIRE,MESSAGE_ERREUR_TELEPHONE_OBLIGATOIRE } from '../../../data/message-erreurs-form';
import { emailSchemaRequired } from '../../../models/schema/emailSchema';

export const CompteSchema = Yup.object().shape({
    IdCivilite: Yup
    .number()
    .required(MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE),
    Email: emailSchemaRequired(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE),
    Nom: Yup
      .string()
      .required(MESSAGE_ERREUR_NOM_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_NOM_OBLIGATOIRE),
    Prenom: Yup
      .string()
      .required(MESSAGE_ERREUR_PRENOM_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_PRENOM_OBLIGATOIRE),
    Telephone: telephoneSchemaRequired(MESSAGE_ERREUR_TELEPHONE_OBLIGATOIRE),
  });

